import { type Theme } from '@mui/material/styles'

import { type SoapSectionKeys } from '@/shared/types/yakurekiSoap'

// SOAP 本体の section 並びと表示ラベル (S/O/A/EP/CP/OP).
export const SOAP_SECTIONS: { key: SoapSectionKeys; label: string }[] = [
  { key: 'subjectives', label: 'S' },
  { key: 'objectives', label: 'O' },
  { key: 'assessments', label: 'A' },
  { key: 'educational_plans', label: 'EP' },
  { key: 'care_plans', label: 'CP' },
  { key: 'observational_plans', label: 'OP' },
]

// 行頭チェックボックススロットの固定幅 (px). 表示行 / 編集中 / 新規行で本文の x を揃えるため
// 共有する (= 操作列を左 1 本に固定. ここを 1 箇所変えれば全行に効く). 実機確認 2026-07-01:
// 26px 案は「存在感大きすぎ」と判定され 22px に確定 (docs/design-system 正典アイコンサイズ
// 14-20 の範囲内).
export const SOAP_LINE_BULLET_WIDTH = 22

// 行の line-height. 表示 (BodyText=body2) と地続きに見せるため、 編集中/新規/「・」スロットの
// 素の Box・InputBase も body2 と同じ比率に揃える (= 字格ドリフト防止).
export const SOAP_LINE_HEIGHT_RATIO = 1.43

// SOAP 本文行のフォントサイズ. 表示は BodyText(body2) で variant 経由のため文字拡大
// (large) に追従するが、 編集中/新規/空表示の素の Box・InputBase は variant を経由しない。
// 拡大漏れを防ぐため body2 variant の (scaleVariant 済) fontSize を参照する。
export const soapLineFontSize = (theme: Theme) =>
  theme.typography.body2.fontSize
